<template>
  <div v-if="loaded">
    <table class="details-table" v-if="templateDetails">
      <tbody>
        <tr>
          <th>Title:</th>
          <td>{{ templateDetails.title }}</td>
        </tr>
        <tr>
          <th>System Name:</th>
          <td>{{ templateDetails.systemName }}</td>
        </tr>
        <tr>
          <th>Type:</th>
          <td>{{ templateDetails.templateType }}</td>
        </tr>
        <tr>
          <th>Description:</th>
          <td>{{ templateDetails.description }}</td>
        </tr>
      </tbody>
    </table>
    <div v-else>
      <p>
        The linked template is no longer available. Please use the button below
        to unlink this document.
      </p>
    </div>
    <div class="mt-1">
      <button type="button" class="btn btn-primary" @click="unlinkTemplate">
        Unlink
      </button>
      <a
        v-if="capabilities.openDocumentTemplate && templateDetails"
        class="btn btn-primary ml-1"
        :href="templateUrl"
        target="_blank"
        >Open in Sharedo</a
      >
    </div>
  </div>
</template>
<script>
import currentTempates from "@/mixins/currentTemplates";
import templates from "@/services/sharedo/templatesService";
import linkedTemplates from "@/services/word/linkedTemplatesService";
import { openDocumentTemplate } from "@/util/urlBuilder";

const unlinkTemplate = async function() {
  const systemName = this.currentTemplates[0];
  await linkedTemplates.unlink(systemName);

  const currentLinkedTemplates = await linkedTemplates.get();
  this.$store.commit("currentTemplates", { templates: currentLinkedTemplates });
};

export default {
  mixins: [currentTempates],
  data: function() {
    return {
      templateDetails: null,
      loaded: false,
    };
  },
  computed: {
    templateUrl: function() {
      return openDocumentTemplate(this.templateDetails.systemName);
    },
  },
  methods: {
    unlinkTemplate,
  },
  mounted: async function() {
    const systemName = this.currentTemplates[0];
    this.logDebug("Loading template", { systemName });

    try {
      this.templateDetails = await templates.getOne(systemName);
      this.logInfo("Loaded template", { template: this.templateDetails });
    } catch {
      this.logWarning("Unable to load template.", { systemName });
      this.templateDetails = null;
    } finally {
      this.loaded = true;
    }
  },
};
</script>
